import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import { useSearchParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import axios from "../../utils/axiosInstance"; 
import { useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import { Box } from "@mantine/core";
import { IconDownload, IconEye } from "@tabler/icons-react";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import Pagination from "rc-pagination";
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
const useStyles = makeStyles(styles);
export default function WinnerLogsTable() {
  const [winnerTableData, setWinnerTableData] = useState([]);
  console.log(winnerTableData, "winnerTableData")
  const [paginationData, setPaginationData] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const classes = useStyles();
  const [searchParams] = useSearchParams();
  const lotteryId = searchParams.get("LotteryId");
   const [loadingDownload, setLoadingDownload] = useState(false);
  const columns = useMemo(() => [

    {
      header: "Transaction Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Lottery Name",
      accessorKey: "lotteryName",
      size: 10,
    },
    {
      header: "Winning Prize",
      accessorKey: "lotteryWinningPrize",
      size: 10,
    },
    {
      header: "Price",
      accessorKey: "price",
      size: 10,
    },
    {
      header: "Ticket Number",
      accessorKey: "ticketNumber",
      size: 10,
    },
    {
      header: "User name",
      accessorKey: "userName",
      size: 10,
    },
  ]);

  useEffect(() => {
    getData(page, limit, lotteryId);
  }, [page, limit, lotteryId]);

  const getData = async (page = 1, limit = 10, lotteryId = "") => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/winnerLogs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            limit,
            lotteryId,
          },
        }
      );


      setWinnerTableData(response.data);
      setPaginationData(response?.data?.metadata);

    } catch (err) {
      console.error("Error fetching winner logs:", err);

      if (
        err?.response?.data?.message ===
        "For security reasons, we locked your account.Please login to continue"
      ) {
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      }
    } finally {
      setLoading(false);
    }
  };

  const updatePage = (newPage) => {
    setPage(newPage);
  };
const handleDownload = async () => {
      try {
         setLoadingDownload(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/winnerLogsDownLoad`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            lotteryId,
          },
          responseType: 'blob',
        });
  
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Winner_Logs_List.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
         if (error?.response?.status === 403) {
        toast.error("You do not have permission to download this file.");
        return;
      } else {
        swal.fire({
          icon: "error",
          text: "error",
        });
      }
      }finally {
      setLoadingDownload(false); // hide loader
    }
    }
  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Winner Logs Table</h4>

            </CardHeader>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <CardBody>
                {winnerTableData?.data?.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                   {winnerTableData?.message}
                  </Box>
                ) : (
                  <>
                    <MantineReactTable
                      columns={columns}
                      enableRowNumbers
                      positionActionsColumn="first"
                      displayColumnDefOptions={{
                        "mrt-row-actions": {
                          mantineTableHeadCellProps: {
                            align: "center",
                          },
                          size: 120,
                        },
                      }}
                      data={winnerTableData?.data || []}
                      enableColumnFilters={false}
                      enableColumnFilterModes={false}
                      enableGlobalFilter={false}
                      enableFilters={false}
                      enableFullScreenToggle={false}
                      enableDensityToggle={false}
                      enableHiding={false}
                      enableColumnResizing={false}
                      enableColumnOrdering={false}
                      initialState={{ showColumnFilters: true }}
                      positionToolbarAlertBanner="bottom"
                      enablePagination={false}
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "16px",
                            padding: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          {loadingDownload ? (
                                        <CircularProgress size={24} style={{ color: "black" }} />
                                      ) : (
                                        <Button
                                          onClick={handleDownload}
                                          style={{ marginLeft: "auto" }}
                                        
                                        >
                                          Export All Rows
                                        </Button>
                                      )}
                        </Box>
                      )}

                    />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "20px",
                      }}
                    >
                      <Pagination
                        pageSize={paginationData?.pageSize || 10}
                        current={paginationData?.currentPage || 1}
                        total={paginationData?.totalCount || 0}
                        onChange={updatePage}
                      />
                    </Box>
                  </>
                   )}
            </CardBody>
            )}
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
